import React from "react";
import { SvgIcon } from "@mui/material";
import { cleanIconProps } from "./cleanIconProps";

const JournalEntriesIcon = (props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      {...cleanIconProps(props)}
    >
      <circle
        style={{ ...props.circleStyle }}
        className="leaves-1"
        cx="150"
        cy="151.08244"
        r="109.58458"
      />
      <g transform="scale(0.50), translate(225 135)">
        <path
          className="doctor-1"
          d="M89.37,91.35c-21,43.84-34.54,90.12-45.87,138.33-8.65-8.5-15.75-16.9-18.91-29l8.52,1A14.7,14.7,0,0,0,32,199.32c-6.62-8.59-8.78-17.78-7.5-28.93,1.94-16.88,6.44-32.91,12-50.37,2.16,5.28,3.84,9.37,5.51,13.46l1.43.11c-5.8-25.09,7.6-43.8,19.84-63.2L70.65,84.2l.57-.34C70.76,78.13,70,72.41,70,66.68c0-2.85.59-6.27,2.21-8.48C89.71,34.42,110.66,14.52,137.85,2c1.59-.74,3.27-1.25,5.22-2-3,11.73-6.52,22.85-8.56,34.23-1.89,10.58-2.38,21.43-3.17,32.19-1.05,14.1-1.66,28.24-2.78,42.34a10.86,10.86,0,0,1-3.21,6.38c-8.55,8.11-17.38,16-26,24.65l26.5-10.07a4,4,0,0,1,0,1.52c-5.06,17.37-10.09,34.76-15.38,52.07a9.6,9.6,0,0,1-4.13,4.69c-6.61,4.05-13.41,7.78-21,12.12l20.47-3.35c-1.7,2.12-2.78,3.63-4,5a85.26,85.26,0,0,1-42,25.74c-3.86,1-5.62,2.85-6.34,6.46-.54,2.77-1.63,5.45-2,8.23-.58,4-2.55,5-6.62,3.55C56.31,193.3,70.26,141.6,89.37,91.35Z"
        />
        <path
          className="doctor-1"
          d="M48.06,315.9c-14.49,0-29-.07-43.46.05-4,0-5.42-1.06-4.14-5.3,3.32-11,6.17-22.11,9.52-33.09.6-2,2.42-3.81,4.12-5.14,3.67-2.85,7.79-5.12,11.42-8,3.85-3.08,3.87-6,.87-9.89-.52-.67-.93-2.26-.59-2.59a5.48,5.48,0,0,1,3.29-1.6c6-.16,12-.09,18-.09,6.66,0,13.32-.09,20,.09,1.25,0,2.48,1.13,3.73,1.74-.62,1-1.2,2.06-1.86,3-2.43,3.63-1.07,6.79,1.76,9.12,3.59,2.94,7.75,5.18,11.39,8.07,1.81,1.44,3.74,3.41,4.39,5.52,3.33,10.81,6.13,21.78,9.4,32.6,1.33,4.41,0,5.61-4.35,5.56C77,315.8,62.54,315.9,48.06,315.9ZM6,300.89H65.77c3.36,0,3.88-1.86,3.09-4.64-1.37-4.8-2.44-9.72-4.21-14.36a6.31,6.31,0,0,0-4.57-3.37c-15-.26-30-.21-45,0A4.59,4.59,0,0,0,11.73,281C9.69,287.33,8,293.76,6,300.89Z"
        />
      </g>
    </SvgIcon>
  );
};

export default JournalEntriesIcon;
